"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _crud = require("@crud/crud");

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _DateRangePicker = _interopRequireDefault(require("@/components/DateRangePicker"));

//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    rrOperation: _RR.default,
    DateRangePicker: _DateRangePicker.default
  },
  mixins: [(0, _crud.header)()],
  props: {
    dict: {
      type: Object,
      required: true
    },
    permission: {
      type: Object,
      required: true
    }
  }
};
exports.default = _default;